import { CONST } from "../sideTypes"
import { MenuItemCategory, MenuItemType, PopupPageId, ProvincesShortCode, ScreenActions } from "../../Components/navigationTypes"




export const getDetailsList: (appCode: ProvincesShortCode, sid: string, isCollege: boolean) => Promise<Array<MenuItemType>> =
    async (appCode, sid, isCollege) => {
        const Contract: MenuItemType =
        {
            label: "Contract",
            navigate: {
                component: "main",
                url: "lfmaster.asp",
            },
            subItems: [
                {
                    label: "Basic",
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            compat: "1",
                            formasp: "purfileedit",
                            id: CONST.uninitialized,
                            tb: "TPAppXML",
                        },
                        controller: {
                            tabName: "Basic",
                            tabNumber: 0,
                        },
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default,
                },
                {
                    label: "Contract",
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Basic",
                            tabNumber: 2,
                        },
                    },
                    PSM: "PSO",
                    addOptions: [],
                    type: MenuItemCategory.Contract
                },
                {
                    label: "Property",
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Basic",
                            tabNumber: 1,
                        },
                    },
                    addOptions: [],
                    type: MenuItemCategory.Property
                },
                {
                    label: "Extra Properties",
                    appCode: ["RPWBC"],
                    PSM: "PSM",
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Basic",
                            tabNumber: 1,
                            autoClick: "ExtraProperties"
                        },
                    },
                    addOptions: [],
                    type: MenuItemCategory.Property
                },
            ],
            addOptions: [],
            type: MenuItemCategory.Heading
        };

        const Buyer: MenuItemType =
        {
            id: "Buyer",
            label: "Buyer Side",
            PSM: "PSOM",
            navigate: {
                component: "main",
            },
            addOptions: [
                {
                    label: "Individual",
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: PopupPageId.Transferee,
                            tabNumber: -1,
                            screenAction: ScreenActions.setTransferIndividual,
                        },
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                },
                {
                    label: "Corporation",
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: PopupPageId.Transferee,
                            tabNumber: -1,
                            screenAction: ScreenActions.setTransferCorporation,
                        },
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                },
                {
                    label: "Estate",
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: PopupPageId.Transferee,
                            tabNumber: -1,
                            screenAction: ScreenActions.setTransferEstate,
                        },
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                },
            ],
            expandable: true,
            type: MenuItemCategory.Heading
        };

        const Issues: MenuItemType =
        {
            id: "Issues",
            label: "Issues",
            navigate: {
                component: "main",
                url: "lfmaster.asp",
                params: {
                    "tb": "TPAppXML",
                    "formasp": "purfileedit",
                    "id": CONST.uninitialized,
                    "PSM": CONST.uninitialized,
                },
                controller: {
                    tabName: "Issues",
                    tabNumber: 0,
                    autoClick: "SearchIssues",
                },
                //action: "AddNewDefectSearch"
            },
            subItems: [
                {
                    label: "All Issues",
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Issues",
                            tabNumber: 0,
                        },
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                },
                {
                    label: "Response to Undertaking",
                    PSM: "S",
                    appCode: ["RPWBC"],
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Issues",
                            tabNumber: 1,
                        },
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                },
                {
                    label: "Undertaking",
                    PSM: "PM",
                    appCode: ["RPWBC"],
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Issues",
                            tabNumber: 1,
                        },
                    },
                    addOptions: [],
                    TitleTransferExclude: true,
                    type: MenuItemCategory.Default
                },
                {
                    label: "Checklist",
                    appCode: ["RPW", "RPWAB", "RPWMB", "RPWNS", "RPWSK"],
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Issues",
                            tabNumber: 3,
                        },
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                },
                {
                    label: "Checklist",
                    appCode: ["RPWBC"],
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Issues",
                            tabNumber: 2,
                        },
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                },
                {
                    label: "Inquiry Status",
                    appCode: ["RPW", "RPWAB", "RPWMB", "RPWNS", "RPWSK"],
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Issues",
                            tabNumber: 1,
                        },
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                },
                {
                    label: "Inquiry Status",
                    appCode: ["RPWBC"],
                    PSM: "PM",
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Issues",
                            tabNumber: 3,
                        },
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                },
                {
                    label: "Objection",
                    appCode: ["RPWNS"],
                    PSM: "PM",
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Issues",
                            tabNumber: 2,
                        },
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                },
                {
                    label: "Description",
                    appCode: ["RPWAB"],
                    PSM: "PM",
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Issues",
                            tabNumber: 2,
                        },
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                },
                {
                    label: "Requisition",
                    PSM: "P",
                    appCode: ["RPW"],
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Issues",
                            tabNumber: 2,
                        },
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                },
                {
                    label: "Report",
                    PSM: "PS",
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Issues",
                            tabNumber: 4,
                        },
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                },
                {
                    label: "Report",
                    PSM: "M",
                    appCode: ["RPWNS"],
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Issues",
                            tabNumber: 4,
                        },
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                },
                {
                    label: "Response Items",
                    appCode: ["RPWAB"],
                    PSM: "S",
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Issues",
                            tabNumber: 2,
                        },
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                },
                {
                    label: "Response to Requisition",
                    appCode: ["RPW"],
                    PSM: "S",
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Issues",
                            tabNumber: 2,
                        },
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                },
                {
                    label: "Title Memorandum",
                    PSM: "M",
                    appCode: ["RPW", "RPWSK", "RPWAB", "RPWMB"],
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Issues",
                            tabNumber: 4,
                        },
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                },
                {
                    label: "Trust Letter",
                    appCode: ["RPWMB"],
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Issues",
                            tabNumber: 2,
                        },
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                },
                {
                    label: "Trust Letter",
                    PSM: "S",
                    appCode: ["RPWSK"],
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Issues",
                            tabNumber: 2,
                        },
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                },
                {
                    label: "Trust Letter Reconciliation",
                    PSM: "P",
                    appCode: ["RPWSK"],
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Issues",
                            tabNumber: 2,
                        },
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                },
            ],
            addOptions: [],
            type: MenuItemCategory.Heading,
            maxSize: 1,
            expandable: true,
        };

        const Seller: MenuItemType =
        {
            id: "Seller",
            label: "Seller Side",
            PSM: "PSO",
            navigate: {
                component: "main",
                url: "lfmaster.asp",
                params: {
                    "formxml": "TransferorDetails",
                    "diagData": "1",
                    "tabNum": String(0)
                }
            },
            addOptions: [
                {
                    label: "Individual",
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: PopupPageId.Transferor,
                            tabNumber: -1,
                            screenAction: ScreenActions.setTransferIndividual,
                        },
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                },
                {
                    label: "Corporation",
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: PopupPageId.Transferor,
                            tabNumber: -1,
                            screenAction: ScreenActions.setTransferCorporation,
                        },
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                },
                {
                    label: "Estate",
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: PopupPageId.Transferor,
                            tabNumber: -1,
                            screenAction: ScreenActions.setTransferEstate,
                        },
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                },
            ],
            expandable: true,
            type: MenuItemCategory.Heading,
        };

        const ThirdParty: MenuItemType =
        {
            id: "Third",
            label: "Additional Parties",
            navigate: {
                component: "main",
                url: "lfmaster.asp",
            },
            addOptions: [
                {
                    label: "Buying Agent",
                    PSM: "PS",
                    appCode: ["RPWAB"],
                    navigate: {
                        component: "main",
                        controller: {
                            tabName: 'Basic',
                            onClickDispatch: 'RealEstateBroker'
                        }
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                },
                {
                    label: "Conveyancer",
                    appCode: ["RPW"],
                    navigate: {
                        component: "main",
                        controller: {
                            tabName: 'Basic',
                            onClickDispatch: 'Conveyancer'
                        }
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                },
                {
                    label: "Fire Insurance",
                    navigate: {
                        component: "main",
                        controller: {
                            tabName: 'Basic',
                            onClickDispatch: 'FireInsurer',
                        }
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                },
                {
                    label: "Mortgage Broker",
                    navigate: {
                        component: "main",
                        controller: {
                            tabName: 'Basic',
                            onClickDispatch: 'MortgageBroker'
                        }
                    },
                    PSM: "PM",
                    appCode: ["RPW"],
                    addOptions: [],
                    type: MenuItemCategory.Default
                },
                {
                    label: "Real Estate Broker",
                    PSM: "PS",
                    appCode: ["RPW"],
                    navigate: {
                        component: "main",
                        controller: {
                            tabName: 'Basic',
                            onClickDispatch: 'RealEstateBroker'
                        }
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                },
                {
                    label: "Real Estate Agent - Purchaser",
                    PSM: "PS",
                    appCode: ["RPWSK", "RPWMB"],
                    navigate: {
                        component: "main",
                        controller: {
                            tabName: 'Basic',
                            onClickDispatch: 'PurchaserRealEstateBroker'
                        }
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                },
                {
                    label: "Real Estate Agent - Vendor",
                    PSM: "PS",
                    appCode: ["RPWSK", "RPWMB"],
                    navigate: {
                        component: "main",
                        controller: {
                            tabName: 'Basic',
                            onClickDispatch: 'RealEstateBroker'
                        }
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                },
                {
                    label: "Real Estate Agent - Purchaser",
                    PSM: "S",
                    appCode: ["RPWNS"],
                    navigate: {
                        component: "main",
                        controller: {
                            tabName: 'Basic',
                            onClickDispatch: 'PurchaserRealEstateBroker'
                        }
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                },
                {
                    label: "Real Estate Agent - Vendor",
                    PSM: "S",
                    appCode: ["RPWNS"],
                    navigate: {
                        component: "main",
                        controller: {
                            tabName: 'Basic',
                            onClickDispatch: 'RealEstateBroker'
                        }
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                },
                {
                    label: "Listing Agent",
                    PSM: "PS",
                    appCode: ["RPWBC"],
                    navigate: {
                        component: "main",
                        controller: {
                            tabName: 'Basic',
                            onClickDispatch: 'RealEstateBroker'
                        }
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                },
                {
                    label: "Selling Agent",
                    PSM: "PS",
                    appCode: ["RPWAB", "RPWBC"],
                    navigate: {
                        component: "main",
                        controller: {
                            tabName: 'Basic',
                            onClickDispatch: 'PurchaserRealEstateBroker'
                        }
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                },
                {
                    label: "Relocation Company",
                    navigate: {
                        component: "main",
                        controller: {
                            tabName: 'Basic',
                            onClickDispatch: "OtherParty",
                            onClickDispatchPayload: {
                                filterType: "Relocation Company"
                            }
                        }
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                },
                {
                    label: "Referral",
                    navigate: {
                        component: "main",
                        controller: {
                            tabName: 'Basic',
                            onClickDispatch: "OtherParty",
                            onClickDispatchPayload: {
                                filterType: "Referral"
                            }
                        }
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                },
                {
                    label: "Water Company",
                    navigate: {
                        component: "main",
                        controller: {
                            tabName: 'Basic',
                            onClickDispatch: "OtherParty",
                            onClickDispatchPayload: {
                                filterType: "Water Company"
                            }
                        }
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                },
            ],
            expandable: true,
            type: MenuItemCategory.Heading
        };

        const Financial: MenuItemType =
        {
            label: "Financial",
            navigate: {
                component: "main"
            },
            subItems: [
                {
                    label: "Statement of Adjustments",
                    appCode: ["RPW", "RPWAB", "RPWMB", "RPWNS", "RPWSK"],
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Financial",
                            tabNumber: 0,
                        },
                    },
                    PSM: "PS",
                    addOptions: [],
                    type: MenuItemCategory.Default,
                },
                {
                    label: "Vendor Adjustments",
                    appCode: ["RPWBC"],
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Financial",
                            tabNumber: 0,
                        },
                    },
                    PSM: "S",
                    TitleTransferExclude: true,
                    addOptions: [],
                    type: MenuItemCategory.Default,
                    requiredFields: [{ field: "getLawyerShowSellerAdjustmentsNew", value: "1" }],
                },
                {
                    label: "Vendor Adjustments",
                    appCode: ["RPWBC"],
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Financial",
                            tabNumber: 0,
                        },
                    },
                    PSM: "P",
                    TitleTransferExclude: true,
                    addOptions: [],
                    type: MenuItemCategory.Default,
                },
                {
                    label: "Purchaser Adjustments",
                    appCode: ["RPWBC"],
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Financial",
                            tabNumber: 1,
                        },
                    },
                    PSM: "P",
                    TitleTransferExclude: true,
                    addOptions: [],
                    type: MenuItemCategory.Default,
                },
                {
                    label: "Account to Client - Interim",
                    PSM: "P",
                    appCode: ["RPW"],
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": "P",
                        },
                        controller: {
                            tabName: "Financial",
                            tabNumber: 5,
                        },
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default,
                    requiredFields: [
                        {
                            field: "getPropertyType",
                            value: "Condo"
                        },
                        {
                            field: "getInterimClosingDate"
                        },
                        {
                            field: "getNewHome",
                            value: "0"
                        }

                    ]
                },
                {
                    label: "Account to Client",
                    appCode: ["RPWAB"],
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Financial",
                            tabNumber: 1,
                        },
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default,
                },
                {
                    label: "Account to Client",
                    appCode: ["RPW", "RPWNS", "RPWSK", "RPWMB"],
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Financial",
                            tabNumber: 2,
                        },
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default,
                },
                {
                    label: "Trust In/Out",
                    appCode: ['RPWBC'],
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Financial",
                            tabNumber: 2,
                        },
                    },
                    PSM: "PSM",
                    addOptions: [],
                    type: MenuItemCategory.Default,
                },
                {
                    label: "Account to Client",
                    appCode: ["RPWBC"],
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Financial",
                            tabNumber: 3,
                        },
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default,
                },
                {
                    label: "Trust Statement",
                    appCode: ["RPW", "RPWNS"],
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Financial",
                            tabNumber: 3,
                        },
                    },
                    PSM: "PSM",
                    addOptions: [],
                    type: MenuItemCategory.Default,
                },
                {
                    label: "Deed Transfer Tax",
                    appCode: ["RPWNS"],
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Financial",
                            tabNumber: 1,
                        },
                    },
                    PSM: "PO",
                    addOptions: [],
                    type: MenuItemCategory.Default,
                },
                {
                    label: "Land Transfer Tax",
                    appCode: ["RPW"],
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Financial",
                            tabNumber: 1,
                        },
                    },
                    PSM: "PO",
                    addOptions: [],
                    type: MenuItemCategory.Default,
                },
                {
                    label: "Estimated Closing Costs",
                    appCode: ['RPWMB'],
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Financial",
                            tabNumber: 1,
                        },
                    },
                    PSM: "P",
                    addOptions: [],
                    type: MenuItemCategory.Default,
                },
                {
                    label: "Estimated Purchaser's Adjustments",
                    appCode: ['RPWSK'],
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Financial",
                            tabNumber: 3,
                        },
                    },
                    PSM: "P",
                    addOptions: [],
                    type: MenuItemCategory.Default,
                },
                {
                    label: "Estimated Vendor's Adjustments",
                    appCode: ['RPWSK'],
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Financial",
                            tabNumber: 3,
                        },
                    },
                    PSM: "S",
                    addOptions: [],
                    type: MenuItemCategory.Default,
                },
                {
                    label: "Estimated Mortgagor's Adjustments",
                    appCode: ['RPWSK'],
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Financial",
                            tabNumber: 3,
                        },
                    },
                    PSM: "M",
                    addOptions: [],
                    type: MenuItemCategory.Default,
                },
                {
                    label: "Closing Funds Summary",
                    appCode: ["RPWAB"],
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Financial",
                            tabNumber: 3,
                        },
                    },
                    PSM: "PSM",
                    addOptions: [],
                    type: MenuItemCategory.Default,
                },
                {
                    label: "Closing Funds Summary",
                    appCode: ["RPW"],
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Financial",
                            tabNumber: 4,
                        },
                    },
                    PSM: "PSM",
                    addOptions: [],
                    type: MenuItemCategory.Default,
                },
                {
                    label: "Trust Statement",
                    appCode: ["RPWMB"],
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Financial",
                            tabNumber: 4,
                        },
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default,
                },
                {
                    label: "Trust Statement",
                    appCode: ['RPWAB'],
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Financial",
                            tabNumber: 2,
                        },
                    },
                    PSM: "PSM",
                    addOptions: [],
                    type: MenuItemCategory.Default,
                },
                {
                    label: "Purchaser's Adjustments",
                    appCode: ["RPWSK"],
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Financial",
                            tabNumber: 4,
                        },
                    },
                    PSM: "P",
                    addOptions: [],
                    type: MenuItemCategory.Default,
                },
                {
                    label: "Vendor's Adjustments",
                    appCode: ["RPWSK"],
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Financial",
                            tabNumber: 4,
                        },
                    },
                    PSM: "S",
                    addOptions: [],
                    type: MenuItemCategory.Default,
                },
                {
                    label: "Mortgagor's Adjustments",
                    appCode: ["RPWSK"],
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Financial",
                            tabNumber: 4,
                        },
                    },
                    PSM: "M",
                    addOptions: [],
                    type: MenuItemCategory.Default,
                },
                {
                    label: "Soluno Export",
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        reactFrame: 'solunoexport',
                        controller: {
                            tabName: "Financial",
                        }
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default,
                    
                },
            ],
            addOptions: [],
            type: MenuItemCategory.Heading,

        };

        const Mortgage: MenuItemType =
        {
            label: "Mortgage",
            navigate: {
                component: "main",
                url: "lfmaster.asp",
                params: {
                    "formxml": "purmort",
                    "tb": "TPAppXML",
                    "id": CONST.uninitialized,
                    "PSM": CONST.uninitialized,
                    "tabNum": String(0),
                }
            },
            addOptions: [
                {
                    label: "Import",
                    id: "ImportRenai",
                    icon: 'renai-icon renai-icon-light',
                    navigate: {
                        component: "main",
                        controller: {
                            onClickDispatch: "MortgageDropbox",
                        },
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default,
                    newBadge: true,
                    // userJSON: "AI",
                },
                {
                    label: 'Inbox & LLC',
                    PSM: "PM",
                    navigate: {
                        component: "main",
                        popup: true,
                        isModal: true,
                        reactModalFrame: "mortimp",
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                },
                {
                    label: 'Lender Centre',
                    PSM: "PM",
                    navigate: {
                        component: "main",
                        controller: {
                            tabName: "Mortgages",
                            tabNumber: 0,
                            autoClick: "openLenderCentre",
                        },
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                },
                {
                    label: "New Standard",
                    navigate: {
                        component: "main",
                        controller: {
                            onClickDispatch: "MortgageLender",
                        },
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                },
                {
                    label: "Assume",
                    appCode: ["RPW", "RPWAB", "RPWMB", "RPWNS"],
                    PSM: "PS",
                    navigate: {
                        component: "main",
                        action: "AddNewMatter3",
                        actionParam: "32_1",
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                },
                {
                    label: "Discharge",
                    appCode: ["RPW", "RPWAB", "RPWMB", "RPWNS"],
                    navigate: {
                        component: "main",
                        action: "AddNewMatter3",
                        actionParam: "32_2",
                        controller: {
                            tabName: "Mortgages",
                        }
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                },
                {
                    label: "Existing Mortgage",
                    appCode: ["RPWBC", "RPWSK"],
                    navigate: {
                        component: "main",
                        action: "AddNewMatter4",
                        actionParam: null,
                        controller: {
                            tabName: "Mortgages",
                        }
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                },
                {
                    label: "Vendor Take Back",
                    PSM: "PS",
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Mortgages",
                            tabNumber: -1,
                            screenAction: ScreenActions.setVTB,
                        },
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                }

            ],
            expandable: true,
            type: MenuItemCategory.Heading
        };

        // const Insurance: MenuItemType =
        // {
        //     label: "",
        //     navigate: undefined,
        //     PSM: "PM",
        //     addOptions: [],
        //     type: MenuItemCategory.Alert,
        //     params: { variant: "primary", text: "Title Insurance is now accessed in your Workspace." }
        // };

        if (isCollege) {
            Mortgage.addOptions = Mortgage.addOptions.filter(option => option.id !== "ImportRenai" && option.label !== "Inbox & LLC" && option.label !== 'Lender Centre');
        }

        return [
            Contract,
            Buyer,
            Seller,
            ThirdParty,
            Mortgage,
            Issues,
            Financial,
        ];
    }
